import React from "react"
import { Provider } from "react-redux"
import { IndeedThemeProvider } from "@indeed/ifl-components"
import Gettext, { GettextInterface, GettextLogger } from "@indeed/indeed-gettext"
import { IndeedToastContainer } from "../common/components/indeed-toast-container"
import { logDatadogRumMessage } from "../common/utils/datadog"
import { I18nProvider } from "../common/utils/i18n-context"
import { I2aWebappRoutes } from "./i2a-webapp-routes"
import { setupStore } from "./store"

let instance: GettextInterface | undefined
const store = setupStore()

export const Main: React.FC = () => {
    function GettextFactory() {
        if (instance) {
            return instance
        }

        const localeData = (window && window["indeed.i18n.localeData"]) || { "": {} }
        const logger: GettextLogger = {
            error: (msg) => {
                logDatadogRumMessage(`getText err: ${msg}`)
            },
        }
        instance = Gettext({ ...localeData, logger })
        return instance
    }

    return (
        <Provider store={store}>
            <I18nProvider value={GettextFactory()}>
                <IndeedThemeProvider>
                    <IndeedToastContainer />
                    <I2aWebappRoutes />
                </IndeedThemeProvider>
            </I18nProvider>
        </Provider>
    )
}
